export default {
  title: 'Galleri',
  sections: {
    logo: 'Logo',
    web_images: 'Galleribilleder til onlinebestilling',
  },
  toasts: {
    image_uploaded: 'Ændringerne er gemt',
    image_upload_failed: 'Ændringerne kunne ikke gemmes',
  },
};
